<span class="status-{{status}}"></span>